






























































































































































import { Button, MDInput, Toggle } from "@micad/vue-components";
import { QBtn, QAvatar } from "quasar";
import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from "@vue/composition-api";
import { ssoInit } from "@/data/repos/preLogin";
import router from "@/router";
import {
  checkSavedSession,
  CheckSavedSessionResponse,
} from "@/data/repos/checkSavedSession";
import Loading from "@/components/Loading.vue";
import { Branding, getBrandingMetadata } from "@/data/repos/branding";
import {
  getActiveNotifications,
  Notification,
} from "@/data/repos/notifications";
import NotificationsPanel from "@/components/Auth/NotificationsPanel.vue";
import BrandingCard from "@/components/Auth/BrandingCard.vue";
import MobileHeader from "@/components/Auth/MobileHeader.vue";
import { getKV } from "@/modules/browserLocalStorage";
import { userDecrypt } from "@/data/repos/userDecrypt";
import {
  getTerms,
  getTermsAgreed,
  setTermsAgreed,
  Term,
} from "@/data/repos/termsAndConditions";
import { getDayEnd, SaveAuth } from "@/modules/auth";
import ModalContainer from "@/components/ModalContainer.vue";
import { Auth } from "@micad/vue-components/src/repos/login";
import { checkLicense, redirectBackToTheClient } from "@/modules/utils";
import { encryptAESBase64 } from "@/modules/crypto";
import { googleOauthRedirect, msOauthRedirect } from "@/modules/sso";

const CLIENT_COOKIE_NAME = "X-Authorization-ClientId";

async function onSubmit(
  clientKey: string | undefined,
  userName: string,
  toggled: boolean,
  app: string | undefined,
  callbackParameters: { returnUrl: string; callbackUrl: string },
  query?: any
) {
  if (toggled) {
    localStorage.setItem("savedUserName", userName);
  } else {
    localStorage.removeItem("savedUserName");
  }
  // Go to Password Login
  await router.push({
    name: "login",
    params: {
      clientKey: String(clientKey),
      userId: userName,
      ...callbackParameters,
    },
    query: {
      ...query,
      cid: clientKey,
      userName,
      app,
      ...callbackParameters,
    },
  });
}

export default defineComponent({
  components: {
    ModalContainer,
    MDInput,
    Button,
    Toggle,
    Loading,
    NotificationsPanel,
    BrandingCard,
    MobileHeader,
    QBtn,
    QAvatar,
  },
  props: {
    pUserName: String,
    pClientKey: String,
    pFixedClientKey: Boolean,
    pCallbackUrl: String,
    pReturnUrl: String,
  },
  setup(p) {
    const query = router.currentRoute.query;
    const qClientKey = router.currentRoute.query.clientKey
      ? String(router.currentRoute.query.clientKey)
      : undefined;
    const qCid = router.currentRoute.query.cid
      ? String(router.currentRoute.query.cid)
      : undefined;
    const qUserName = router.currentRoute.query.userName
      ? String(router.currentRoute.query.userName)
      : undefined;
    const qReturnUrl = router.currentRoute.query.returnUrl
      ? String(router.currentRoute.query.returnUrl)
      : undefined;
    const qCallbackUrl = router.currentRoute.query.callbackUrl
      ? String(router.currentRoute.query.callbackUrl)
      : undefined;
    const nonce = ref<string | undefined>("");
    ssoInit().then((resp) => (nonce.value = resp.payload?.parameters.nonce));
    const state = reactive({
      app: ((query.app || "") as string) || undefined,
      showLoginDialog: false,
      userName: p.pUserName || "",
      toggled: false,
      clientKey: p.pClientKey || qClientKey || qCid || undefined,
      clientKeyHint: getKV(CLIENT_COOKIE_NAME) || undefined,
      fixedClientKey: !!(
        p.pFixedClientKey || router.currentRoute.query.fixedClientKey
      ),
      notifications: [] as Notification[],
      onSubmit,
      forgottenPassword,
      termsAgreed: null as boolean | null,
      showTermsDialog: false,
      terms: [] as Term[],
      loginResponse: {} as CheckSavedSessionResponse,
      agreeToTerms,
      registerUser,
      callbackParameters: {
        returnUrl: p.pReturnUrl || qReturnUrl || "",
        callbackUrl: p.pCallbackUrl || qCallbackUrl || "",
      },
      serverErrorMessage: "",
      branding: {} as Branding,
      brandingPresent: computed<boolean>(
        (): boolean =>
          !!state.branding.text ||
          (state.branding.images && !!state.branding.images.length)
      ),
      query: router.currentRoute.query,
      googleOauth,
      msOauth,
    });
    function msOauth() {
      msOauthRedirect(
        state.clientKey,
        qCallbackUrl,
        qReturnUrl,
        nonce.value,
        state.app
      );
    }
    function googleOauth() {
      googleOauthRedirect(
        state.clientKey,
        qCallbackUrl,
        qReturnUrl,
        nonce.value,
        state.app
      );
    }

    async function decryptUserName(u: string | undefined) {
      if (!u) return u;
      const resp = await userDecrypt(u);
      if (resp.ok && resp.payload) state.userName = resp.payload.userName;
    }
    decryptUserName(qUserName);
    function forgottenPassword() {
      router.push({
        name: "forgot-password",
        query: {
          userName: state.userName,
          clientKey: state.clientKey,
          originalUrl: window.location.href,
        },
      });
    }
    function registerUser() {
      router.push({
        name: "register",
        query: {
          originalUrl: window.location.href,
          clientKey: query.clientKey,
        },
      });
    }

    // check for saved userName
    const savedUserName = localStorage.getItem("savedUserName");
    if (savedUserName != null) {
      state.toggled = true;
      state.userName = savedUserName;
    }

    function readyForPasswordLogin() {
      if (
        router.currentRoute.query.userName &&
        router.currentRoute.query.clientKey &&
        router.currentRoute.query.callbackUrl
      ) {
        const { clientKey, userName } = router.currentRoute.query;
        onSubmit(
          clientKey ? String(clientKey) : clientKey,
          userName ? String(userName) : userName,
          state.toggled,
          state.app,
          {
            callbackUrl: String(router.currentRoute.query.callbackUrl),
            returnUrl: String(router.currentRoute.query.returnUrl),
          },
          router.currentRoute.query
        );
        return true;
      } else return false;
    }
    async function checkTermsAgreed(app: string | undefined): Promise<boolean> {
      if (state.termsAgreed || !app) return true;
      const agreed = (await getTermsAgreed(app)).payload;
      return agreed!.termsAgreed;
    }
    async function agreeToTerms() {
      state.termsAgreed = true;
      await setTermsAgreed(String(state.app));
      await redirect(state.loginResponse);
    }

    async function redirect(resp: CheckSavedSessionResponse) {
      SaveAuth({
        userId: resp.userId,
        sessionId: resp.sessionId,
        expiry: resp.expirationTimestamp || getDayEnd().toISOString(),
      } as Auth);
      if (!(await checkLicense(query))) return;
      if (await checkTermsAgreed(state.app)) {
        redirectBackToTheClient(
          decodeURIComponent(
            String(router.currentRoute.query.callbackUrl || "")
          ),
          {
            client_key: resp.clientKey,
            user_id: resp.userId,
            session_id:
              state.query.state && state.query.nonce
                ? await encryptAESBase64(
                    resp.sessionId,
                    state.query.nonce as string,
                    state.query.state as string
                  )
                : resp.sessionId,
            state: state.query.state as string | undefined,
            expiration: resp.expirationTimestamp || getDayEnd().toISOString(),
            return_uri: String(router.currentRoute.query.returnUrl) || "",
            // login_token: response.loginToken,
          }
        );
      } else {
        state.loginResponse = resp;
        const termsResp = await getTerms(state.app, true);
        console.log(
          "loaded terms:",
          termsResp.payload!.length,
          termsResp.payload
        );
        if (termsResp.ok && termsResp.payload!.length) {
          state.terms = termsResp.payload as Term[];
          state.showTermsDialog = true;
        } else {
          state.showTermsDialog = false;
          state.termsAgreed = true;
          await redirect(state.loginResponse);
        }
      }
    }
    function haveForRedirectLoop(cbUrl: string) {
      const itemKey = `visit:${cbUrl}`;
      const [tsStr, visitsStr] = (sessionStorage.getItem(itemKey) || "").split(
        ":"
      );
      const ts = parseInt(tsStr);
      const visits = parseInt(visitsStr);
      if (ts && Date.now() - ts < 5000)
        if (visits > 5) return true;
        else sessionStorage.setItem(itemKey, `${Date.now()}:${visits + 1}`);
      else sessionStorage.setItem(itemKey, `${Date.now()}:1`);
      return false;
    }
    setTimeout(async () => {
      if (haveForRedirectLoop(query.callbackUrl as string)) {
        console.error("Redirect loop:", query.callbackUrl);
        const errorMessage = `The page ${query.callbackUrl} is creating a redirect loop. Please contact your administrator to get help.`;
        router.push({ name: "Error", query: { errorMessage } }).then();
        return;
      }
      const resp = await checkSavedSession();
      const bestBefore = new Date();
      bestBefore.setUTCHours(23, 59, 59, 999);
      if (resp.ok && resp.payload) {
        // if there is a valid session and no callbackUrl redirect to the main page
        if (state.query.oidc) {
          router
            .push({
              name: "OIDC",
              query: {
                oidc: state.query.oidc,
                session_id: resp.payload.sessionId,
                expiration:
                  resp.payload.expirationTimestamp || getDayEnd().toISOString(),
              },
            })
            .then();
          return;
        }
        if (!resp.payload.clientKey) {
          await router.push({
            name: "chooseClient",
            query: {
              returnUrl: router.currentRoute.query.returnUrl,
            },
          });
          return;
        }
        if (!router.currentRoute.query.callbackUrl) {
          await router.push({ name: "Home" });
          return;
        }
        if (state.clientKey && state.clientKey !== resp.payload.clientKey) {
          alert(
            "You are about to login with " +
              state.clientKey +
              ". If you continue your " +
              resp.payload.clientKey +
              " session will be terminated."
          );
          state.showLoginDialog = true;
          return;
        }
        await redirect(resp.payload);
      } else {
        if (readyForPasswordLogin()) return;
        else state.showLoginDialog = true;
      }
    }, 200);
    async function retrieveNotifications() {
      const clientKey = state.clientKey || state.clientKeyHint || "";
      state.notifications =
        (await getActiveNotifications(clientKey, state.app)).payload || [];
    }

    async function retrieveBranding() {
      if (!state.clientKey && !state.clientKeyHint) return;
      await retrieveNotifications();
      state.branding =
        (
          await getBrandingMetadata(
            "login",
            String(state.clientKey || state.clientKeyHint),
            state.app || undefined
          )
        ).payload || ({} as Branding);
    }
    setTimeout(() => retrieveBranding(), 0);

    watch(
      () => state.showLoginDialog,
      () => {
        setTimeout(
          () =>
            (
              document.getElementById("userName") || { focus: () => null }
            ).focus(),
          500
        );
      },
      { immediate: true }
    );

    return state;
  },
});
